export const SAVE_CYCLE = 'saveCycle';
export const SAVE_CYCLE_CHANGES = `${SAVE_CYCLE}/SaveCycleChanges`;

